// @flow
import * as React from 'react';
import styled from 'styled-components';
import Truncate from 'components/Truncate';
import Label from 'components/Label';
import { BodySmall } from 'components/Text';
import TabContext from 'containers/TabContext';
import { colors, textStyles } from '../theme';

const StyledInput = styled(
  ({ isTabbing, ...props }: { isTabbing: boolean }) => <input {...props} />
)`
  height: 14px;
  width: 14px;
  border: 0;
  border-radius: 3px;
  background: ${colors.aluminum};
  padding: 3px;
  cursor: pointer;
  margin: 0;
  margin-right: 18px;
  ${textStyles.bodySmall}
  &:not(:checked) {
    appearance: none;
  }
  ${props =>
    !props.isTabbing &&
    `
    outline: 0;
  `}
`;

const Checkbox = ({ ...inputProps }) => (
  <StyledInput {...inputProps} type="checkbox" />
);

const OptionContainer = styled.div`
  &:not(:first-child) {
    margin-top: 8px;
  }
`;

export default ({
  title,
  isSelected,
  toggle,
  value
}: {
  title: string,
  isSelected: boolean,
  toggle: Function,
  value: string
}) => (
  <OptionContainer>
    <TabContext.Consumer>
      {isTabbing => (
        <Label
          data-qa-id="side-filter"
          data-qa-selected={isSelected}
          data-qa-value={value}
          alignItems="center"
        >
          <Checkbox
            onChange={toggle}
            checked={isSelected}
            isTabbing={isTabbing}
          />
          <Truncate>
            <BodySmall color={colors.greyishBrown}>{title}</BodySmall>
          </Truncate>
        </Label>
      )}
    </TabContext.Consumer>
  </OptionContainer>
);
